import { Booking } from "../../types";

interface Props {
  record?: Booking;
  label?: string;
  addLabel?: boolean;
}

const BookingTopUp: React.FC<Props> = (props) => {
  const { record: booking } = props;

  if (!booking) {
    return <></>;
  }

  const bookingTopUps = booking.booking_topups ?? [];
  if (bookingTopUps.length === 0) {
    return <></>;
  }

  return (
    <div>
      {bookingTopUps
        .map((bookingTopUp) => bookingTopUp.transaction_number)
        .join(", ")}
    </div>
  );
};
BookingTopUp.defaultProps = {
  label:
    process.env.REACT_APP_COMPANY_CODE === "STMY"
      ? "Return Transaction Number"
      : "Top Up Transaction Number",
  addLabel: true,
};

export default BookingTopUp;
